<template>
  <div style="width: 1180px; margin: 0 auto">
    <base-bread-crumb
      class="bread-crumb"
      :currBreadCrumb="currBreadCrumb"
      :isShowPortal="true"
    ></base-bread-crumb>
    <div class="ccui-app-container">
      <div class="ccui-multifunctional-table-wrapper dialog-body">
        <div class="nocaptcha-wp" v-if="isnocaptcha">
          <NoCaptcha
            ref="NoCaptcha"
            class="nocaptcha"
            @successAWSC="successAWSC"
          />
        </div>
        <!-- 分包商找回密码 -->
        <div class="tis">{{ $t("subFindPassword.title") }}</div>
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-width="160px"
          class="ccui-form"
        >
          <!-- 单位全称： -->
          <el-form-item
            :label="$t('subFindPassword.subconName')"
            prop="reqname"
          >
            <!-- 请输入单位全称 -->
            <el-input
              v-model="form.reqname"
              class="ccui-form-shortInput"
              :placeholder="$t('subFindPassword.subconNamePlaceholder')"
              clearable
              maxlength="50"
            />
          </el-form-item>
          <!-- 类型： -->
          <el-form-item :label="$t('subFindPassword.type')" prop="type">
            <!-- 请选择类型 -->
            <el-select
              v-model="form.type"
              clearable
              :placeholder="$t('subFindPassword.typePlaceholder')"
              class="ccui-form-shortInput"
              @change="changeType"
            >
              <!-- 分包商  供应商  商家  采购单位 -->
              <el-option
                key="分包商"
                :label="$t('subFindPassword.subcontractor')"
                value="0"
              ></el-option>
              <el-option
                key="供应商"
                :label="$t('subFindPassword.supplier')"
                value="1"
              ></el-option>
              <el-option
                key="商家"
                :label="$t('subFindPassword.merchant')"
                value="2"
              ></el-option>
              <el-option
                key="采购单位"
                :label="$t('subFindPassword.purchaseUnit')"
                value="4"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 是否境外： -->
          <el-form-item
            v-if="form.type === '0'"
            :label="$t('subFindPassword.isOverseas')"
            prop="isOverseas"
          >
            <el-radio-group v-model="form.isOverseas">
              <el-radio label="0">{{ $t("subFindPassword.no") }}</el-radio>
              <el-radio label="1">{{ $t("subFindPassword.yes") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 邮箱： -->
          <el-form-item
            v-if="form.type !== '0' || form.isOverseas === '1'"
            :label="$t('subFindPassword.email')"
            prop="reqemail"
          >
            <!-- 请输入邮箱 -->
            <el-input
              style="margin-right: 5px"
              v-model="form.reqemail"
              class="ccui-form-shortInput"
              :placeholder="$t('subFindPassword.emailPlaceholder')"
              clearable
              maxlength="50"
            />
            <el-button
              v-if="form.type === '0'"
              @click="sendCode"
              :disabled="isSend"
              ><span v-if="isSend"
                >{{ countDown }}{{ $t("subAppeal.second") }}</span
              >{{ $t("subAppeal.sendCode") }}</el-button
            >
          </el-form-item>
          <!-- 手机号码： -->
          <el-form-item
            v-if="form.type !== '0' || form.isOverseas === '0'"
            :label="$t('subFindPassword.phoneNumber')"
            prop="reqmobile"
          >
            <!-- 请输入手机号码 -->
            <div
              :style="{
                display: 'flex',
                width: phoneFieldWidth,
                justifyContent: 'space-between'
              }"
            >
              <el-input
                style="margin-right: 5px"
                v-model="form.reqmobile"
                :placeholder="$t('subFindPassword.phoneNumberPlaceholder')"
                clearable
                maxlength="11"
              />
              <el-button @click="sendCode" :disabled="isSend"
                ><span v-if="isSend"
                  >{{ countDown }}{{ $t("subAppeal.second") }}</span
                >{{ $t("subAppeal.sendCode") }}</el-button
              >
            </div>
          </el-form-item>
          <!-- 验证码： -->
          <el-form-item
            :label="$t('subAppeal.verificationCode')"
            prop="smsCode"
          >
            <el-input
              v-model="form.smsCode"
              class="ccui-form-shortInput"
              :placeholder="$t('subAppeal.verificationCodePlaceholder')"
              clearable
              maxlength="50"
            />
          </el-form-item>
          <!-- 附件上传： -->
          <el-form-item :label="$t('subFindPassword.attachmentTemplate')">
            <a
              class="donload-font"
              :download="$t('subFindPassword.findPasswordTemplate')"
              href="https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/cccc_temp/temp25582ca272664fd99c05de84382dbe5b.doc"
              >{{ $t("subFindPassword.clickDownload") }}</a
            >
            {{ $t("subFindPassword.attachmentTemplatePlaceholder") }}
          </el-form-item>
          <!-- 附件上传： -->
          <el-form-item :label="$t('subAppeal.attachmentUpload')">
            <el-upload
              :show-file-list="false"
              :action="url"
              style="display: inline-block"
              :before-upload="beforeAvatarUpload"
              :on-success="onSuccess"
              :on-progress="onProgress"
              :on-error="onError"
            >
              <!-- :data="fromData" -->
              <div slot="tip" class="el-upload__tip">
                <!-- 只能上传doc/docx/pdf文件，且不超过50M -->
                {{ $t("subAppeal.attachmentUploadPlaceholder") }}
              </div>
              <el-button plain type="single-number">
                {{ $t("subAppeal.clickUpload") }}
              </el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="">
            <div class="file-list" :title="fileList[0].fileName">
              {{ fileList[0].fileName }}
            </div>
          </el-form-item>
        </el-form>
        <div style="padding-left: 96px" class="dialog-footer">
          <el-button
            style="width: 140px"
            type="primary"
            @click="submit"
            :disabled="showBtn"
            >{{ $t("subAppeal.submit") }}</el-button
          >
          <el-button style="width: 140px" @click="handleClose">{{
            $t("subAppeal.reset")
          }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import {
  add,
  send,
  checkSendEmailCode,
  checkEmailVerificationCode
} from "@/app/shop/api/shopping";
import NoCaptcha from "./NoCaptcha.vue";
import BaseBreadCrumb from "@/app/noticesList/components/baseBreadCrumb.vue";
import { addUrlPerFix } from "@/basa/utils";

export default {
  name: "subFindPassword",
  components: { NoCaptcha, BaseBreadCrumb },
  props: {},
  data() {
    let checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t("subAppeal.phoneNumberEmpty")));
      } else {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error(this.$t("subAppeal.phoneNumberFormat")));
        }
      }
    };
    return {
      currBreadCrumb: [{ title: this.$t("subFindPassword.title") }],
      code: "",
      countDown: 60,
      isSend: false,
      showBtn: true,
      dialogVisible: false,
      isnocaptcha: false,
      form: {
        reqname: "",
        reqemail: "",
        reqmobile: "",
        type: "",
        fileurl: "",
        smsCode: "",
        isOverseas: ""
      },
      fromData: { openId: "", userName: "" },
      rules: {
        reqname: [
          {
            required: true,
            message: this.$t("subFindPassword.subconNamePlaceholder"),
            trigger: "blur"
          }
        ],
        isOverseas: [
          {
            required: true,
            message: this.$t("subFindPassword.isOverseasPlaceholder"),
            trigger: "change"
          }
        ],
        reqemail: [
          {
            required: true,
            message: this.$t("subAppeal.emailPlaceholder"),
            trigger: ["blur", "change"]
          },
          {
            type: "email",
            message: this.$t("subAppeal.emailFormat"),
            trigger: "blur"
          }
        ],
        reqmobile: [
          {
            required: true,
            validator: checkPhone,
            trigger: ["blur", "change"]
          }
        ],
        type: [
          {
            required: true,
            message: this.$t("subAppeal.typePlaceholder"),
            trigger: ["blur", "change"]
          }
        ]
      },
      fileList: [
        {
          fileName: ""
        }
      ],
      url: `${addUrlPerFix(
        process.env.VUE_APP_BASEP_URL
      )}/apis/basap/users/signup/uploadLogo`
    };
  },
  methods: {
    changeType(val) {
      if (val === "0") {
        this.form.isOverseas = "0";
      } else {
        this.form.isOverseas = "";
      }
    },
    sendCode() {
      if (this.form.isOverseas === "0") {
        if (!this.form.reqmobile) {
          this.$message.warning(this.$t("subAppeal.phoneNumberEmpty") + "！");
          return;
        }
      } else if (this.form.isOverseas === "1") {
        if (!this.form.reqemail) {
          this.$message.warning(this.$t("subAppeal.emailEmpty") + "！");
          return;
        }
      }
      this.isnocaptcha = true;
    },
    successAWSC(obj) {
      this.isnocaptcha = false;
      this.showBtn = obj.disabledBtn;
      this.code = obj.code;
      if (this.form.isOverseas === "0") {
        send({
          reqmobile: this.form.reqmobile,
          sessionId: obj.code,
          agentId: 100003
        }).then(res => {
          if (res.data.code == "0" && res.data.message == "成功") {
            let timer = setInterval(() => {
              if (this.countDown > 0) {
                this.countDown--;
                this.isSend = true;
              } else {
                clearInterval(timer);
                this.isSend = false; // 启用按钮
                this.countDown = 60; // 重置倒计时时间
              }
            }, 1000);
          }
        });
      } else if (this.form.isOverseas === "1") {
        checkSendEmailCode({
          email: this.form.reqemail,
          sessionId: obj.code,
          languageFlag: Cookies.get("language")
        }).then(res => {
          if (res.data.code == "0" && res.data.message == "成功") {
            let timer = setInterval(() => {
              if (this.countDown > 0) {
                this.countDown--;
                this.isSend = true;
              } else {
                clearInterval(timer);
                this.isSend = false; // 启用按钮
                this.countDown = 60; // 重置倒计时时间
              }
            }, 1000);
          }
        });
      }
    },
    handleClose(done) {
      this.$refs.form.resetFields();
      this.fileList = [{ fileName: "" }];
      this.showBtn = true;
      this.isnocaptcha = false;
    },
    beforeAvatarUpload(file) {
      if (this.fileList.length > 1) {
        this.$message.warning(this.$t("subAppeal.singleUpload"));
        return;
      }
      const isLt50 = file.size < 52428800;
      var testmsg = file.name.substring(file.name.lastIndexOf("."));
      let fileType = [
        ".doc",
        ".docx",
        ".DOC",
        ".DOCX",
        ".pdf",
        ".PDF"
      ].includes(testmsg);
      if (!isLt50) {
        // "文件大小不超过50M!"
        this.$message({
          showClose: true,
          message: this.$t("subAppeal.fileSizeLimit"),
          type: "error",
          duration: 0
        });
      }
      if (file.size === 0) {
        // "文件大小不可为0B!"
        this.$message({
          showClose: true,
          message: this.$t("subAppeal.fileSizeLimitEmpty"),
          type: "error",
          duration: 0
        });
      }
      if (!fileType) {
        // "上传文件格式错误！"
        this.$message({
          showClose: true,
          message: this.$t("subAppeal.uploadFileFormatError"),
          type: "error",
          duration: 0
        });
      }
      return isLt50 && fileType && file.size > 0;
    },
    onProgress(res) {
      this.uploadLoading = this.$loading({
        lock: true,
        text: this.$t("subAppeal.uploadLoading"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    onSuccess(res) {
      let fileData = res.data[0];
      this.$set(this.fileList, 0, {
        fileName: fileData.fileName
      });
      this.form.fileurl = fileData.downloadUrl;
      this.$message.success(this.$t("subAppeal.uploadSuccess"));
      this.uploadLoading.close();
    },
    onError() {
      // "上传至服务器失败请重新上传"
      this.$message.error(this.$t("subAppeal.uploadError"));
      this.uploadLoading.close();
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!this.form.fileurl) {
            this.$message.error(this.$t("subAppeal.uploadEmpty"));
            return;
          }
          if (this.form.isOverseas === "0") {
            this.$confirm(this.$t("subFindPassword.confirmPhoneNumber"), "", {
              iconClass: "el-icon-info"
            })
              .then(_ => {
                add({
                  ...this.form,
                  agentId: 100001,
                  sessionId: this.code
                }).then(res => {
                  this.$message({
                    message: this.$t("subFindPassword.submitSuccess"),
                    type: "success",
                    duration: 3000,
                    ccuiCustom: true,
                    showClose: true,
                    offset: document.documentElement.clientHeight / 2 - 21
                  });
                  this.handleClose();
                  setTimeout(() => {
                    this.$router.go(-1);
                  }, 3000);
                });
              })
              .catch(_ => {
                this.handleClose();
              });
          } else if (this.form.isOverseas === "1") {
            checkEmailVerificationCode({
              email: this.form.reqemail,
              verificationCode: this.form.smsCode
            }).then(val => {
              if (val.data.message === "成功") {
                add({
                  ...this.form,
                  agentId: 100001,
                  sessionId: this.code
                }).then(res => {
                  this.$message({
                    message: this.$t("subFindPassword.submitSuccess"),
                    type: "success",
                    duration: 3000,
                    ccuiCustom: true,
                    showClose: true,
                    offset: document.documentElement.clientHeight / 2 - 21
                  });
                  this.handleClose();
                  setTimeout(() => {
                    this.$router.go(-1);
                  }, 3000);
                });
              }
            });
          }
        } else {
          this.isnocaptcha = false;
          this.showBtn = true;
          return false;
        }
      });
    }
  },
  filter: {},
  computed: {
    phoneFieldWidth() {
      return Cookies.get("language") === "en-gb" ? "470px" : "300px";
    }
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
.tis {
  font-size: 18px;
  font-weight: 600;
  border-bottom: 1px dashed #999999;
  padding: 12px 0;
  margin-bottom: 25px;
}
.bread-crumb {
  padding: 20px 0;
  margin: 0 !important;
}
.ccui-form .ccui-form-shortInput {
  width: 300px;
}
.file-list {
  width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: default;
}
.donload-font {
  color: #0089ef;
  text-decoration: underline;
}
.el-dialog__body .el-form /deep/.el-form-item {
  margin-bottom: 27px !important;
}
.dialog-body {
  position: relative;
  .nocaptcha-wp {
    top: 0;
    background: #0000006f;
    width: 100%;
    height: 100%;
    z-index: 10;
    position: absolute;
    .nocaptcha {
      margin: 20% auto;
      width: 300px !important;
    }
  }
}
</style>
